import {
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { fetchEventEnter } from '@/api/event.ts';
import { UserData } from '@/api/event.types.ts';
import { ApiError } from '@/api/error/api.errors.ts';

const useEventEnterQuery = (
  eventId: string,
): UseSuspenseQueryResult<UserData, ApiError | null> => {
  return useSuspenseQuery({
    staleTime: Infinity,
    gcTime: Infinity,
    queryKey: getQueryKey(eventId),
    queryFn: () => fetchEventEnter(eventId),
  });
};

const getQueryKey = (eventId: string) => ['terms-enter', eventId];
useEventEnterQuery.getQueryKey = getQueryKey;

export default useEventEnterQuery;
